import { truncateName } from "@/api/helper";
import Badge from "@/components/core/badge";
import DataTable, { type ColumnDef } from "@/components/core/data-table";
import Pagination from "@/components/core/pagination";
import { Route } from "@/routes/_dashboard.bcc-dashboard";
import { formatDate } from "@/utils/format-date";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "@tanstack/react-router";
import { caseRecordsQueryOptions } from "../case-record/api/queries/case-records-query";
import type { CaseRecord } from "../case-record/types/case-records";

export default function IncomingCases() {
	const search = Route.useSearch();
	const navigate = useNavigate();

	const casesQuery = useSuspenseQuery(
		caseRecordsQueryOptions({
			...search,
			status: "branch_receiving",
		}),
	);

	const meta = casesQuery.data.meta;
	const cases = casesQuery.data?.data;
	const columns: ColumnDef<Cases>[] = [
		{
			id: "case_number",
			label: "Case No.",
			cell: ({ data, onClick }) => (
				<Link to={`/case-evaluation/${data.id}?status=pending`} className="font-semibold text-blue-600 hover:text-blue-500">
					{data.case_number}
				</Link>
			),
		},
		{
			id: "case_title",
			label: "Case Title",
			cellClassName: "",
			cell: ({ data }) => data.case_title,
		},
		{
			id: "case_category",
			label: "Case Category",
			cell: ({ data }) => data.case_category,
		},
		{
			id: "created_at",
			label: "Date Filed",
			cellClassName: "",
			headerClassName: "",
			cell: ({ data }) => formatDate(data.filed_at, "PPp"),
		},
		{
			id: "raffled_at",
			label: "Date Raffled",
			cellClassName: "",
			headerClassName: "",
			cell: ({ data }) => formatDate(data.raffled_at, "PPp"),
		},
	];

	return (
		<div className="flex flex-col w-full py-1 px-3">
			<DataTable className="border-collapse" data={cases} columns={columns} stickyHead={false} stickyCol={false} showBorder={false} compact={true} />

			<Pagination
				onClick={async (page) => {
					await navigate({
						to: "/occ-dashboard",
						search: (old) => ({
							...old,
							page,
						}),
					});
				}}
				initialPage={meta.current_page}
				pageCount={meta.last_page}
			/>
		</div>
	);
}
